/** Sport logos for My Games cards — paths match Pick'em frontend (`getSportLogoUrl`). */
export function getMyGamesSportLogoPath(sport?: string): string | null {
  if (!sport) return null;
  const s = sport.trim().toUpperCase();
  if (s === 'NFL' || s === 'NCAAFB' || s === 'NCAAF') return '/leagues/nfl-logo.svg';
  if (s === 'NBA') return '/leagues/nba-logo.svg';
  // Generic basketball mark — there is no WNBA asset, and the NBA's own mark is the
  // wrong league's branding rather than a neutral stand-in.
  if (s === 'WNBA') return '/basketball-logo.svg';
  if (s === 'NHL') return '/leagues/nhl-logo.svg';
  if (s === 'MLB') return '/leagues/mlb-logo.svg';
  if (s === 'NCAAMB' || s === 'NCAA') return '/leagues/Arbysncaa-logo.png';
  if (s === 'SOCCER' || s === 'FOOTBALL') return '/soccer-logo.svg';
  if (s === 'PGA') return '/pga-logo.svg';
  if (s === 'MMA') return '/mma-logo.svg';
  if (s === 'NASCAR') return '/nascar-logo.svg';
  if (s === 'TENNIS') return '/tennis-logo.svg';
  return null;
}
